function getElementFromRef(ref) {
  if (ref && 'current' in ref) {
    return ref.current;
  }
  return ref;
}

export { getElementFromRef as g };
//# sourceMappingURL=getElementFromRef-3993f795-83939d54.js.map
